<template>
    <div class="position-relative">
        <router-view />
    </div>
</template>

<script>
export default{
    async beforeMount() {
        await this.getSessionUser();
    }
}
</script>